import { StyleSheet } from 'aphrodite';
import { antiFlashWhite, brandSecondary, label, titles } from '../../../../styles/colors';
import { CssSelectors } from '../../../../styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		display: `flex`,
		flexDirection: `column`,
		height: `calc(80vh - 76px)`,
	},
	header: {
		color: titles,
		fontSize: 18,
		textAlign: 'center',
		marginBottom: 16,
	},
	modal: {
		':nth-child(1n) > .modal-overlay': {
			':nth-child(1n) > .modal-overlay-content': {
				height: '80vh',
				width: 640,
			},
		},
	},
	searchContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		marginBottom: 8,
		...CssSelectors.allChildren(
			{
				width: '100%',
			},
			'div'
		),
	},
	templateCard: {
		display: `flex`,
		flexDirection: `column`,
		gap: 8,
		boxSizing: `border-box`,
		padding: 12,
		position: 'relative',
		borderRadius: 6,
		border: `1px solid ${antiFlashWhite}`,
		boxShadow: '0px 0px 6px rgba(139, 139, 139, 0.100034)',
		cursor: 'pointer',
		...CssSelectors.allDescendants(
			{
				border: `1px dashed ${brandSecondary}`,
				borderRadius: 3,
				boxSizing: 'border-box',
				fontSize: 14,
				padding: '1px 5px',
			},
			'span[data-placeholder="true"]'
		),
	},
	templateCardHeader: {
		display: `flex`,
		justifyContent: `space-between`,
	},
	templateCardHeaderTitle: {
		display: 'flex',
		alignItems: 'center',
		gap: 4,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		fontSize: 14,
		fontWeight: 500,
		whiteSpace: 'nowrap',
	},
	templateSocialIndicator: {
		position: 'absolute',
		zIndex: 5,
		top: 0,
		right: 0,
	},
	templateSocialPopover: {
		borderBottomRightRadius: 0,
		boxSizing: 'border-box',
		color: label,
		fontSize: 12,
		lineHeight: '18px',
		marginLeft: 14,
		maxWidth: 240,
		padding: 4,
	},
	cardsContainer: {
		display: `flex`,
		flexDirection: `column`,
		gap: 8,
		overflow: `auto`,
	},
	trigger: {
		height: 40,
		marginBottom: 8,
		width: '100%',
	},
	templateCardButtonContainer: {
		display: 'flex',
		justifyContent: 'flex-start',
		marginTop: 8,
	},
});
